import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import ConfigurationOrientation from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Shared/TranscriptionIssue/ConfigurationOrientation';
import RetryTranscriptionButton from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Shared/TranscriptionIssue/RetryTranscriptionButton';
import SpeakerFailureOrientation from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Shared/TranscriptionIssue/SpeakerFailureOrientation';
import type TranscriptionIssueView from '@UI/Store/WorkflowRuns/Views/TranscriptionIssueView';
import { css } from '@emotion/react';
import type * as React from 'react';

const issueStyle = css`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.5rem;
`;

const messageStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.medium};
	color: ${theme.states.danger.ink};
`;

type Props = {
	readonly subject: SubjectAddress;
	readonly issue: TranscriptionIssueView;
};

/**
 * The failing or blocked transcription step of an interview: the server's message, what to configure
 * when the cause is a missing engine, and the retry gesture when the server allows one.
 */
const TranscriptionIssue: React.FC<Props> = ({ subject, issue }) => {
	return (
		<div css={issueStyle} role="alert">
			<p css={messageStyle}>{issue.message}</p>
			<ConfigurationOrientation issue={issue} />
			<SpeakerFailureOrientation issue={issue} />
			<ConditionalLoader data={issue.canRetry}>
				<RetryTranscriptionButton subject={subject} issue={issue} />
			</ConditionalLoader>
		</div>
	);
};

export default TranscriptionIssue;
